// const CHANGE_VALUES = 'directOrderRecurring/CHANGE_VALUES';
const SET_SHIPMENT_KEYS = 'directOrderRecurring/SET_SHIPMENT_KEYS';

const changeTime$ = 'directOrderRecurring/changeTime$';
const selectTime$ = 'directOrderRecurring/selectTime$';
const onBlurTimePicker$ = 'directOrderRecurring/onBlurTimePicker$';

const changeDate$ = 'directOrderRecurring/changeDate$';

const changeAddress$ = 'directOrderRecurring/changeAddress$';
const cleanAddress$ = 'directOrderRecurring/cleanAddress$';

export default {
  // CHANGE_VALUES,
  SET_SHIPMENT_KEYS,

  changeTime$,
  selectTime$,
  onBlurTimePicker$,

  changeDate$,

  changeAddress$,
  cleanAddress$,
};
